import Vue from 'vue';
import Router from 'vue-router';
import Component from 'vue-class-component';
import store from '@/store';
import { buildRouter } from '@/router';

Vue.use(Router);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate'
]);

const router = buildRouter({
  getScenario: () => store.getters['scenario/getFields'],
  getReport: () => store.getters['scenario/getAlgoResult'],
  hasTechnicalReport: () => store.getters['scenario/hasTechnicalReport'],
  loadPresets: () => {
    // TODO load all application presets here
    const promises = ['references/init', 'generator/loadPresets', 'references/loadInflation', 'references/loadFx', 'references/loadFd']
      .map((action) => store.dispatch(action));
    return Promise.all(promises);
  }
});

export default router;
